import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HomeState {
    vehicleVisibility: { [keys: string]: boolean };
}

const initialHomeState: HomeState = {
    vehicleVisibility: {},
};

export const homeSlice = createSlice({
    name: "home",
    initialState: initialHomeState,
    reducers: {
        toggleVehicleRouteVisibility: (state, payload: PayloadAction<string>) => {
            const vehicleID = payload.payload;
            // Undefined is the default state which is visible so that goes to false
            if (state.vehicleVisibility[vehicleID] === undefined) {
                state.vehicleVisibility[vehicleID] = false;
            } else {
                state.vehicleVisibility[vehicleID] = (
                    !state.vehicleVisibility[vehicleID]);
            }
        },
    },
});

export const { toggleVehicleRouteVisibility } = homeSlice.actions;
export default homeSlice.reducer;
